import {
  AnimalSizeTypeOrdered,
  BreedFciGroupType,
  BreedMaintenanceType,
  DogHairTypeOrdered,
} from '@application/types';
import { binarySelectOptions, enumSelectOptions } from '@application/utils';
import type { AnimalSizeEnum, DogHairType } from '@gql/graphql';
import { DogType } from '@gql/graphql';
import {
  FiltersWithModalInputSelectField,
  FiltersWithModalInputWrapper,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Form } from 'formik';
import type { FC } from 'react';

export const Filters: FC<unknown> = () => {
  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({ keyPrefix: 'common.inputs' });

  return (
    <Form>
      <FiltersWithModalInputWrapper width="280px">
        <FiltersWithModalInputSelectField<BreedFciGroupType>
          multiple
          name="fciGroupType"
          options={enumSelectOptions(translate, 'enum.breedFciGroupType', BreedFciGroupType)}
          placeholder={translateRessource('breedFciGroupType.placeholder')}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<DogHairType>
          multiple
          name="hairType"
          options={enumSelectOptions(translate, 'enum.dogHairType', DogHairTypeOrdered as any)}
          placeholder={translateRessource('hairType.placeholder')}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<AnimalSizeEnum>
          multiple
          name="size"
          options={enumSelectOptions(translate, 'enum.animalSize', AnimalSizeTypeOrdered as any)}
          placeholder={translateRessource('size.placeholder')}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<DogType>
          multiple
          name="dogType"
          options={enumSelectOptions(translate, 'enum.dogType', DogType)}
          placeholder={translateRessource('dogType.placeholder')}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<BreedMaintenanceType>
          multiple
          name="maintenanceType"
          options={enumSelectOptions(translate, 'enum.breedMaintenanceType', BreedMaintenanceType)}
          placeholder={translateRessource('maintenanceType.placeholder')}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<boolean>
          name="independant"
          options={binarySelectOptions(translate)}
          placeholder={translateRessource('independant.placeholder')}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper width="220px">
        <FiltersWithModalInputSelectField<boolean>
          name="allergic"
          options={[{ value: true, label: translate('common.buttons.yes') }]}
          placeholder={translateRessource('allergic.placeholder')}
        />
      </FiltersWithModalInputWrapper>
    </Form>
  );
};
